import * as React from 'react';
import {useContext} from 'react';
import {
    filterOpenedSections,
    filterReasons,
    getTableHeadersName,
    toggleSection
} from "../../../processes/massive_actions/CensusCooler/pages/CensusStatusPage/utils";
import {DesAccordion} from "../../../components/DesAccordion";
import {useCensusEnums} from "../../../processes/massive_actions/CensusCooler/data/hooks/CecnsusCoolerControllerHooks";
import {Section} from "../../../processes/massive_actions/CensusCooler/pages/CensusStatusPage/types";
import {CensusDetailsContext} from "../../providers/CensusDetailsProvider";
import './styles.scss';
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {FinalEquipmentWithStatusSection} from "../FinalEquipmentWithStatusSection";
import AutoSizer from "react-virtualized-auto-sizer";
import {Display} from "../../../components/Display";
import {Loader} from "../../../components/Utils/loader/Loader";
import {delay} from "@vebox/etui-core";
import {mapOpenedSectionsIntoInitialState} from "./utils";

interface CensusFinalEquipmentListProps {
    toggleDrawer: () => void;
}

export const CensusFinalEquipmentList: React.FC<CensusFinalEquipmentListProps> = ({toggleDrawer}) => {

    const {
        mappedSummary,
        isLoadingActions,
        updateLastUserPosition,
        lastUIUserPosition
    } = useContext(
        CensusDetailsContext)
    const {data} = useCensusEnums(true);
    const [openedSections, setOpenedSections] = React.useState<Section[]>(lastUIUserPosition?.openedSection ?? []);
    const [isLoading, setIsLoading] = React.useState<boolean>(true);

    const previousOpenedSections = React.useMemo(
        () => mapOpenedSectionsIntoInitialState(lastUIUserPosition?.openedSection ?? []),
        [lastUIUserPosition?.openedSection?.length]);

    const toggleSections = (section: Section) => {
        const sections = toggleSection(section, openedSections);
        setOpenedSections(sections);
        updateLastUserPosition({...lastUIUserPosition, openedSection: sections})
    };

    const renderData = (height: string) => {
        if (!isLoadingActions && data?.actions && mappedSummary?.length > 0) {
            return mappedSummary
                ?.filter(filterOpenedSections(data, openedSections))
                ?.map((summary, index) => {
                    const {
                        inventoryStatus,
                        inventoryStatusDetail,
                        inventoryStatusReason,
                        withReason,
                        count,
                        finalAction
                    } = summary;
                    return (
                        <FinalEquipmentWithStatusSection
                            status={inventoryStatus}
                            statusDetail={inventoryStatusDetail}
                            inventoryStatusReason={inventoryStatusReason}
                            detailCount={withReason?.filter(
                                filterReasons(data, openedSections),
                            )}
                            suggestedAction={summary?.suggestedAction}
                            finalAction={finalAction}
                            translatedActionsEnum={data?.actions}
                            equipmentCount={count}
                            tableHeaderName={getTableHeadersName(
                                data,
                                inventoryStatus,
                                inventoryStatusDetail,
                            )}
                            level={0}
                            height={height}
                            toggleSection={toggleSections}
                            descriptions={data?.descriptions}
                            toggleDrawer={toggleDrawer}
                            previousOpenedSections={previousOpenedSections}
                        />
                    );
                });
        }
        return [];
    }


    React.useEffect(() => {
        delay(250).then(() =>
            setIsLoading(false))
    }, [])

    return (
        <div className={"census-final-equipment-list-container"}>
            <VeBoxCard className={"Section"}>
                <VeBoxCard.Body className={"height-100"}>
                    <Display isVisible={isLoading}>
                        <div className={"loader-container-100"}>
                            <Loader relativelyCentered={true}/>
                        </div>
                    </Display>
                    <Display isVisible={!isLoading}>
                        <AutoSizer style={{height: "100%"}} disableWidth={true}>
                            {({height}) =>
                                <div className={"accordion-container"}>
                                    <DesAccordion
                                        enableSingleSectionOpen={true}
                                        initialState={previousOpenedSections[0]}
                                    >
                                        {renderData(`calc(${height}px - 2px)`)}
                                    </DesAccordion>
                                </div>
                            }
                        </AutoSizer>
                    </Display>

                </VeBoxCard.Body>
            </VeBoxCard>
        </div>
    );
}